// import Evaluation360 from './Evaluation360';

export default {
  // component: Evaluation360,
  path: 'requests',
  priority: 800,
  permissions: ['RequestsMenu/'], //['RequestDashboardMenu', 'ReceivedMenu', 'SentMenu', 'DraftMenu', 'PatternDefinitionMenu', 'PatternAssignmentMenu', 'WorkflowMenu', 'RequestHistoryMenu'],
  name: app.translate('routes.home.requests.Requests'),
  icon: 'email-variant',
  drawer: true,
};


